import {Reducer} from "redux";
import {IStoresContainerState} from "./stores";
import {IStoresAction, StoresAction} from "./stores.actions";

export const initialStoresState: IStoresContainerState = {
    isFetchingStores: false,
    isSearchedStores: false,
    noStoresFound: false,
};

export const storesReducer: Reducer<IStoresContainerState, IStoresAction> = (state = initialStoresState, action) => {
    switch (action.type) {
        case StoresAction.GET_STORES: {
            return {
                ...state,
                isFetchingStores: true,
            };
        }
        case StoresAction.SET_STORES: {
            return {
                ...state,
                stores: action.stores,
                isFetchingStores: false,
            };
        }
        case StoresAction.AWAITING: {
            return {
                ...state,
                isFetchingStores: true,
            }
        }
        case StoresAction.COMPLETED: {
            return {
                ...state,
                isFetchingStores: false,
            }
        }
        case StoresAction.SET_USER_LOCATION: {
            return {
                ...state,
                userLocation: action.userLocation
            }
        }
        case StoresAction.GET_STORES_IN_MAP: {
            return {
                ...state,
                isFetchingStores: true,
                isSearchedStores: false,
            }
        }
        case StoresAction.GET_STORES_FROM_SEARCH: {
            return {
                ...state,
                isFetchingStores: true,
                isSearchedStores: true,
            }
        }
        case StoresAction.NO_STORES_FOUND: {
            return {
                ...state,
                noStoresFound: action.noStoresFound,
                isFetchingStores: false
            }
        }
        default:
            return state;
    }
};
